import React, { useState } from "react";
import CommentIcon from "@mui/icons-material/Comment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import moment from "jalali-moment";

// import JS files

// import others files

const Header = ({ ticket_num, view_number,created_at, id, publish_at,sub_header,header }) => {
  return (
    <>
      <div className="bg-mygrays-100 rounded-lg p-4">
        <div className="md:flex justify-between items-center text-myblacks-200 text-xs">
          <div className="mb-2 md:mb-0">
            <span>شناسه خبر: {id}</span>
          </div>
          <div className=" flex justify-between items-center">
            {/* <div className="flex items-center">
              <CommentIcon sx={{ fontSize: "1rem" }} />
              <span className="mr-1">{ticket_num} نظر</span>
            </div>
            <div className="flex items-center mr-8">
              <RemoveRedEyeIcon sx={{ fontSize: "1rem" }} />
              <span className="mr-1">{view_number}</span>
            </div> */}
            <div className="flex items-center mr-8">
              <AccessTimeIcon sx={{ fontSize: "1rem" }} />
              <span className="mr-1">
                {" "}
                {new Date(created_at).toLocaleTimeString(navigator.language, {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12:false
                })}
               
              </span>
            </div>{" "}
            <div className="flex items-center mr-8">
              <CalendarMonthIcon sx={{ fontSize: "1rem" }} />
              <span className="mr-1">
                {" "}
                {moment(publish_at, "YYYY/MM/DD")
                  .locale("fa")
                  .format("YYYY/MM/DD")}
              </span>
            </div>
          </div>
        </div>
        <div className="my-4">
          <span className="text-base md:text-xl text-myblacks-200 font-bold">
            {sub_header}{" "}
          </span>
        </div>
        <div className="mb-4 mt-8">
          <span className=" text-myblacks-400 font-bold text-2xl md:text-3xl">
            {header}{" "}
          </span>
        </div>
      </div>
    </>
  );
};

export default Header;
